// removed by extract-text-webpack-plugin
module.exports = {"isolates":"GeneratedAppIcon__isolates___1L19T","multiply":"GeneratedAppIcon__multiply___3AkF_"};


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/packages/components/GeneratedAppIcon/GeneratedAppIcon.scss
// module id = 540
// module chunks = 0